import { TypeVas } from '../../interfaces/TypeVas/TypeVas'
import { TypeVasAction } from '../actions/typeVasAction'
import { typeVasActionTypes } from '../types/typeVasActionTypes'

export interface TypeVasState {
  typeVasState: {
    typeVas?: TypeVas[]
    error?: string | undefined
  }
}

const initialState: TypeVasState = {
  typeVasState: { typeVas: [], error: '' }
}

export const typeVasReducer = (
  state: TypeVasState = initialState,
  action: TypeVasAction
): TypeVasState => {
  if (action.type === typeVasActionTypes.GET_TYPE_VAS_EXITO) {
    return {
      ...state,
      typeVasState: {
        typeVas: action.typeVas,
        error: action.error
      }
    }
  }
  return state
}
